exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-step-results-js": () => import("./../../../src/pages/step/results.js" /* webpackChunkName: "component---src-pages-step-results-js" */),
  "component---src-pages-step-save-results-js": () => import("./../../../src/pages/step/save-results.js" /* webpackChunkName: "component---src-pages-step-save-results-js" */),
  "component---src-templates-section-js": () => import("./../../../src/templates/section.js" /* webpackChunkName: "component---src-templates-section-js" */)
}

